"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const oilcontrolhair = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-oilcontrolhair` : '') + (description ? ` desc-oilcontrolhair` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-oilcontrolhair"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-oilcontrolhair"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.68 14.43c.4 0 .7.25.83.52.12.26.14.6-.04.9-.35.6-.5 1.68-.15 2.6.17.43.44.81.83 1.08.38.27.93.47 1.71.47a3 3 0 0 0 1.73-.47c.4-.27.67-.66.85-1.1.36-.93.24-2-.09-2.6a.95.95 0 0 1 0-.9.9.9 0 0 1 .81-.5h8.04a.75.75 0 0 1 0 1.5H16c.25.92.23 2.06-.17 3.05a3.87 3.87 0 0 1-1.39 1.78c-.68.47-1.54.74-2.58.74a4.4 4.4 0 0 1-2.57-.74 3.78 3.78 0 0 1-1.37-1.79 4.81 4.81 0 0 1-.1-3.04H.88a.75.75 0 0 1 0-1.5h7.8Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.27 5.04a.4.4 0 0 1 .31.1c.18.17.15.41.04.58-.68 1-1.8 2.76-2.22 4.17-.26.9-.46 1.93-.56 2.81a8.4 8.4 0 0 0-.06 1.17c.02.33.06.55.11.65.16.31.37.71.54 1.13.18.42.31.89.31 1.39 0 .5-.16.97-.48 1.31-.31.35-.76.55-1.3.55-.49 0-1-.11-1.39-.44-.4-.34-.63-.87-.63-1.59 0-.6.23-1.18.44-1.6a5.7 5.7 0 0 1 .39-.64v-.12l.12-.67c.13-.61.38-1.61.87-3.14A14 14 0 0 1 15 5.17l.06-.05a.44.44 0 0 1 .22-.08Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.44 6.96a.2.2 0 0 1 .17.09c.44.69 1.63 2.65 1.63 3.94a1.8 1.8 0 0 1-3.6 0c0-1.3 1.19-3.25 1.63-3.94a.2.2 0 0 1 .17-.1Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 2.1a.2.2 0 0 1 .17.09c.44.69 1.63 2.65 1.63 3.94a1.8 1.8 0 0 1-3.6 0c0-1.3 1.19-3.25 1.63-3.94a.2.2 0 0 1 .17-.1Z",
    fill: "#232323"
  }));
};
var _default = exports.default = oilcontrolhair;